<template>
  <BaseIcon
    v-if="iconPath"
    :src="iconPath"
    :size="size"
    :width="width"
    :height="height"
    :svgClass="svgClass"
    :wrapperClass="wrapperClass"
    :fill="fill"
    :stroke="stroke"
    :title="title"
    :viewBox="viewBox"
    :preserveAspectRatio="preserveAspectRatio"
    :removeSizeAttrs="removeSizeAttrs"
    :extraAttrs="extraAttrs"
    :inlineProps="inlineProps"
  />
  <span v-else class="icon--missing">❌</span>
</template>

<script>
import BaseIcon from './BaseIcon.vue'

// Webpack require.context для динамического импорта всех SVG
const req = require.context('@/assets/icons/importing', false, /\.svg$/)
const icons = req.keys().reduce((acc, path) => {
  const name = path.replace('./', '').replace('.svg', '')
  acc[name] = req(path)
  return acc
}, {})

export default {
  name: 'AppIcon',
  components: { BaseIcon },
  props: {
    name: { type: String, required: true }, // имя иконки
    size: { type: [String, Number], default: '' },
    width: { type: [String, Number], default: '' },
    height: { type: [String, Number], default: '' },
    svgClass: { type: [String, Array, Object], default: '' },
    wrapperClass: { type: [String, Array, Object], default: '' },
    fill: { type: String, default: '' },
    stroke: { type: String, default: '' },
    title: { type: String, default: '' },
    viewBox: { type: String, default: '' },
    preserveAspectRatio: { type: String, default: '' },
    removeSizeAttrs: { type: Boolean, default: false },
    extraAttrs: { type: Object, default: () => ({}) },
    inlineProps: { type: Object, default: () => ({}) }
  },
  computed: {
    iconPath() {
      return icons[this.name] || ''
    }
  }
}
</script>

<style scoped>
.icon--missing {
  display: inline-block;
  width: 1em;
  height: 1em;
  text-align: center;
  color: red;
}
</style>
